var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4Wd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 599.04 247.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbb040;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66{stroke-width:0px;}.cls-2{fill:url(#New_Gradient_Swatch_4);}.cls-3{fill:url(#New_Gradient_Swatch_5);}.cls-4{fill:url(#New_Gradient_Swatch_6);}.cls-5{fill:url(#New_Gradient_Swatch_1);}.cls-6{fill:url(#New_Gradient_Swatch_3);}.cls-7{fill:url(#New_Gradient_Swatch_2);}.cls-8{fill:url(#New_Gradient_Swatch_5-2);}.cls-9{fill:url(#New_Gradient_Swatch_6-2);}.cls-10{fill:url(#New_Gradient_Swatch_1-2);}.cls-11{fill:url(#New_Gradient_Swatch_3-2);}.cls-12{fill:url(#New_Gradient_Swatch_2-6);}.cls-13{fill:url(#New_Gradient_Swatch_2-5);}.cls-14{fill:url(#New_Gradient_Swatch_2-7);}.cls-15{fill:url(#New_Gradient_Swatch_2-3);}.cls-16{fill:url(#New_Gradient_Swatch_2-4);}.cls-17{fill:url(#New_Gradient_Swatch_2-2);}.cls-18{fill:url(#New_Gradient_Swatch_4-2);}.cls-19{fill:url(#linear-gradient);}.cls-20{fill:url(#radial-gradient);}.cls-21{fill:#ef4136;}.cls-22{fill:#6d6e71;}.cls-23{fill:#f15a29;}.cls-24{fill:url(#linear-gradient-33);}.cls-25{fill:url(#linear-gradient-29);}.cls-26{fill:url(#linear-gradient-32);}.cls-27{fill:url(#linear-gradient-30);}.cls-28{fill:url(#linear-gradient-31);}.cls-29{fill:url(#linear-gradient-34);}.cls-30{fill:url(#linear-gradient-28);}.cls-31{fill:url(#linear-gradient-25);}.cls-32{fill:url(#linear-gradient-11);}.cls-33{fill:url(#linear-gradient-12);}.cls-34{fill:url(#linear-gradient-13);}.cls-35{fill:url(#linear-gradient-10);}.cls-36{fill:url(#linear-gradient-17);}.cls-37{fill:url(#linear-gradient-16);}.cls-38{fill:url(#linear-gradient-19);}.cls-39{fill:url(#linear-gradient-15);}.cls-40{fill:url(#linear-gradient-23);}.cls-41{fill:url(#linear-gradient-21);}.cls-42{fill:url(#linear-gradient-18);}.cls-43{fill:url(#linear-gradient-14);}.cls-44{fill:url(#linear-gradient-22);}.cls-45{fill:url(#linear-gradient-20);}.cls-46{fill:url(#linear-gradient-27);}.cls-47{fill:url(#linear-gradient-24);}.cls-48{fill:url(#linear-gradient-26);}.cls-49{fill:#f26522;}.cls-50{fill:#000;}.cls-51{fill:url(#radial-gradient-2);}.cls-52{fill:url(#radial-gradient-3);}.cls-53{fill:url(#radial-gradient-4);}.cls-54{fill:#be1e2d;}.cls-55{fill:url(#linear-gradient-4);}.cls-56{fill:url(#linear-gradient-2);}.cls-57{fill:url(#linear-gradient-3);}.cls-58{fill:url(#linear-gradient-8);}.cls-59{fill:url(#linear-gradient-9);}.cls-60{fill:url(#linear-gradient-7);}.cls-61{fill:url(#linear-gradient-5);}.cls-62{fill:url(#linear-gradient-6);}.cls-67{isolation:isolate;}.cls-63{opacity:.4;}.cls-63,.cls-65{fill:#fff;}.cls-64{fill:#d1d3d4;}.cls-68{mix-blend-mode:multiply;opacity:.5;}.cls-66{fill:#231f20;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 277.74,
    y1: 210.44,
    x2: 277.74,
    y2: 173.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be1e2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#b81e2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#a91e29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#902024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#6d211e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#402315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#3c2415"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1417.3,
    y1: -99.53,
    x2: 1428.43,
    y2: -99.53,
    gradientTransform: "translate(-1364.01 250.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3c2415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#4e2318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#7e2021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#a11f27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#b61e2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#be1e2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#b81e2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#a91e29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#902024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#6d211e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#402315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c2415"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1022.11,
    y1: 1133.23,
    x2: -1010.98,
    y2: 1133.23,
    gradientTransform: "translate(1144.57 -980.32)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1741.38,
    y1: 73.12,
    x2: 1752.51,
    y2: 73.12,
    gradientTransform: "translate(-1320.87 78.14)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -704.09,
    y1: 949.62,
    x2: -692.97,
    y2: 949.62,
    gradientTransform: "translate(1193.77 -796.71)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5",
    x1: 92.19,
    y1: 241.11,
    x2: 92.19,
    y2: 184.48,
    gradientTransform: "translate(4.81 -2.14) rotate(1.36)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#603913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4",
    x1: 92.19,
    y1: 247.7,
    x2: 92.19,
    y2: 155.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3",
    x1: 92.19,
    y1: 163.07,
    x2: 92.19,
    y2: 239.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 92.19,
    y1: 175.97,
    x2: 92.19,
    y2: 227.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 92.19,
    y1: 177.61,
    x2: 92.19,
    y2: 225.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b29b4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c2415"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -318.81,
    cy: -289.3,
    fx: -318.81,
    fy: -289.3,
    r: 26.57,
    gradientTransform: "translate(357.67 442.02) scale(.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdf6d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b29b4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 92.19,
    y1: 192.66,
    x2: 92.19,
    y2: 209.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5-2",
    x1: 461.06,
    x2: 461.06,
    gradientTransform: "translate(5.17 -11.45) rotate(1.43)",
    xlinkHref: "#New_Gradient_Swatch_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-2",
    x1: 461.06,
    x2: 461.06,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-2",
    x1: 461.06,
    x2: 461.06,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 461.06,
    x2: 461.06,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 461.06,
    x2: 461.06,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 124.17,
    fx: 124.17,
    r: 26.57,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 461.06,
    x2: 461.06,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 2105.2,
    y1: 183.14,
    x2: 2105.2,
    y2: 97.87,
    gradientTransform: "translate(2566.71) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#603913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#39220b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 91.16,
    y1: 186.99,
    x2: 91.16,
    y2: 100.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#603913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#462a0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#201306"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#080501"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 346.58,
    y1: 16.62,
    x2: 346.58,
    y2: 80.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#276f67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#2a6862"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#345754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 232.87,
    y1: 16.62,
    x2: 232.87,
    y2: 80.01,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 496.43,
    y1: 9.95,
    x2: 496.43,
    y2: 165.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#403f41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 209.7,
    y1: 9.95,
    x2: 209.7,
    y2: 165.19,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 525.05,
    y1: 128.71,
    x2: 525.05,
    y2: 90.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#2b2a2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#171718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#0a0a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 405.95,
    y1: 118.91,
    x2: 405.95,
    y2: 120.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#ececed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#babbbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 405.95,
    y1: 118.91,
    x2: 405.95,
    y2: 120.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#5e5f61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#6f7072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8c8d8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#b4b5b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 290.38,
    y1: 149.8,
    x2: 290.38,
    y2: 114.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#2b2a2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#171718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#0a0a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_6",
    x1: 279.06,
    y1: 184.46,
    x2: 279.06,
    y2: 176.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#959799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#b5b7b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c9cbcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#d9dbdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#eaebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2",
    x1: 166.7,
    y1: 187.51,
    x2: 166.7,
    y2: 170.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808285"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-2",
    x1: 2079.4,
    x2: 2079.4,
    gradientTransform: "translate(-1691.75 357.98) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 92.19,
    y1: 89.11,
    x2: 92.19,
    y2: 167.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1",
    x1: 281.9,
    y1: 75.86,
    x2: 281.9,
    y2: 20.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 29.12,
    y1: 88.68,
    x2: 29.12,
    y2: 122.84,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-3",
    x1: 27.68,
    y1: 124.2,
    x2: 27.68,
    y2: 92.39,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 27.68,
    y1: 109.74,
    x2: 36.59,
    y2: 109.74,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 180.11,
    y1: 62.9,
    x2: 203.21,
    y2: 62.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#4c4b4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#646467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6d6e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5f5f62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#4e4e50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#444345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 464.99,
    y1: 89.11,
    x2: 464.99,
    y2: 167.16,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-2",
    x1: 587.13,
    y1: 156.15,
    x2: 587.13,
    y2: 138.74,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-4",
    x1: 277.41,
    y1: 94.73,
    x2: 277.41,
    y2: 82.15,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 277.41,
    y1: 94.09,
    x2: 277.41,
    y2: 82.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-5",
    x1: 277.17,
    y1: 91.65,
    x2: 277.17,
    y2: 85.33,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-6",
    x1: 371.59,
    y1: 90.44,
    x2: 371.59,
    y2: 77.85,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 371.59,
    y1: 89.79,
    x2: 371.59,
    y2: 78.51,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-7",
    x1: 371.35,
    y1: 87.35,
    x2: 371.35,
    y2: 81.04,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 0,
    y1: 137.27,
    x2: 23.9,
    y2: 137.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808285"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 16.87,
    y1: 88.91,
    x2: 16.87,
    y2: 180.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: -406.33,
    cy: -406.58,
    fx: -406.33,
    fy: -406.58,
    r: 5.13,
    gradientTransform: "translate(357.67 442.02) scale(.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: -409.27,
    cy: -320.33,
    fx: -409.27,
    fy: -320.33,
    r: 5.13,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_6-2",
    x1: 321.82,
    y1: 5.47,
    x2: 321.82,
    y2: -0.53,
    xlinkHref: "#New_Gradient_Swatch_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 569.38,
    y1: 99.71,
    x2: 586.51,
    y2: 99.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 579.04,
    y1: 117.35,
    x2: 579.04,
    y2: 82.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed1c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be1e2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 581.57,
    y1: 89.97,
    x2: 581.57,
    y2: 105.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f15a29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 581.59,
    y1: 106.23,
    x2: 581.59,
    y2: 115.43,
    xlinkHref: "#linear-gradient-6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cars"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M461.74,191.73l-145.82-24.1c-2.37-.39-4.22-2.27-4.58-4.65h0c-.45-3.03-3.27-5.12-6.29-4.67l-17.09,2.54c-4.56.68-9.19.64-13.73-.11l-23.09-3.82c-3.02-.5-5.87,1.54-6.37,4.56l-.32,1.95c-.39,2.37-2.27,4.22-4.65,4.58l-145.89,21.68c-5.34.79-9.03,5.77-8.24,11.11h0c.79,5.34,5.77,9.03,11.11,8.24l170.12-25.28c9.29-1.38,18.74-1.3,28.01.23l163.64,27.05c5.33.88,10.37-2.73,11.25-8.06h0c.88-5.33-2.73-10.37-8.06-11.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M571.16,144.6v-45.22h-162.39v25.89h-241.34v-23.61H29.12l-14.96,77.33s40.91,5.97,77,2.94c19.27-1.62,32.63-5.53,40.9-8.82,7.17-1.86,12.13-3.45,12.13-3.45,0,0,.86-1.17,3.64-.95s11.34,0,13.69,0,7.92,2.19,10.91,3.45c3,1.26,47.71,0,232.72,0,1.14,0,2.79-.63,4.68-1.52l46.49,4.31c.54,1.36,1.37,2.46,2.34,2.63,2.29.42,40.55-6.82,51.34-9.04l3.73,1.62,4.72-.47,57-14.42c.37-.33,14.77-2.1,14.77-2.1v-8.56h-19.04ZM48.54,164.43c3.4,2.22,9.99.85,15.23,3.71,1.17,3.93-37.34,2.64-26.68-7.99l11.45,4.28ZM457.62,168.7c-.47.03-.84.21-1.13.48-9.46-.48-32.28-.43-43.05-.38,3.8-1.99,7.83-4.13,10.36-4.22,0,0,34.7,1.59,40.45,1.48,3.66-.07,27.54-2.25,42.58-3.89l1.85,2.89-51.06,3.63Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 53.36,
    y: 123.5,
    width: 11.13,
    height: 55.71,
    transform: "translate(-64.25 45.48) rotate(-28.05)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 122.48,
    y: 125.03,
    width: 11.13,
    height: 55.71,
    transform: "translate(93.6 -43.54) rotate(30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 420.57,
    y: 123.5,
    width: 11.13,
    height: 55.71,
    transform: "translate(-21.12 218.16) rotate(-28.05)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 489.69,
    y: 125.03,
    width: 11.13,
    height: 55.71,
    transform: "translate(142.8 -227.15) rotate(30)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 92.19,
    cy: 201.11,
    r: 15.27,
    transform: "translate(-4.76 2.25) rotate(-1.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M92.19,155.44c-25.22,0-45.67,20.45-45.67,45.67s20.45,45.67,45.67,45.67,45.67-20.45,45.67-45.67-20.45-45.67-45.67-45.67ZM92.19,226.95c-14.27,0-25.84-11.56-25.84-25.84s11.57-25.84,25.84-25.84,25.84,11.57,25.84,25.84-11.57,25.84-25.84,25.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.43,207.52c.04-.23.32-.37.63-.32l4.11.73c.27-1.82.43-3.66.48-5.54h-4.17c-.31,0-.56-.19-.56-.42v-1.71c0-.24.25-.43.56-.43h4.17c-.05-1.87-.22-3.72-.48-5.54l-4.11.73c-.3.06-.59-.08-.63-.31l-.3-1.68c-.04-.23.18-.46.48-.51l4.12-.73c-.37-1.83-.86-3.62-1.44-5.37l-3.93,1.43c-.29.1-.59.01-.67-.21l-.58-1.61c-.08-.22.09-.48.38-.59l3.93-1.43c-.69-1.73-1.47-3.41-2.35-5.04l-3.62,2.09c-.27.16-.58.12-.7-.08l-.85-1.48c-.12-.21,0-.49.27-.65l3.61-2.08c-.97-1.58-2.04-3.1-3.19-4.55l-3.19,2.68c-.24.2-.55.22-.7.04l-1.1-1.31c-.15-.18-.08-.48.16-.68l3.19-2.68c-1.23-1.39-2.54-2.7-3.93-3.93l-2.68,3.19c-.2.24-.5.31-.68.16l-1.31-1.1c-.18-.15-.16-.47.04-.71l2.68-3.19c-1.45-1.15-2.97-2.22-4.55-3.19l-2.09,3.61c-.15.27-.44.39-.65.27l-1.48-.85c-.2-.11-.24-.43-.08-.7l2.09-3.62c-1.62-.88-3.3-1.66-5.04-2.35l-1.43,3.93c-.1.29-.36.47-.58.39l-1.61-.58c-.22-.08-.31-.39-.2-.68l1.43-3.93c-1.74-.58-3.54-1.06-5.37-1.44l-.73,4.12c-.05.31-.29.52-.51.48l-1.68-.29c-.23-.04-.37-.32-.32-.63l.73-4.11c-1.81-.27-3.66-.43-5.53-.48v4.17c0,.31-.19.56-.42.56h-1.71c-.24,0-.42-.25-.42-.56v-4.17c-1.87.05-3.72.21-5.53.48l.72,4.11c.05.31-.09.59-.32.62l-1.69.3c-.23.04-.46-.17-.51-.48l-.72-4.12c-1.83.38-3.62.86-5.37,1.44l1.43,3.93c.11.29.02.59-.21.67l-1.6.59c-.22.08-.48-.09-.59-.38l-1.43-3.93c-1.73.68-3.41,1.47-5.04,2.35l2.09,3.62c.15.27.12.58-.09.7l-1.48.85c-.2.12-.5,0-.65-.27l-2.09-3.61c-1.58.97-3.1,2.04-4.55,3.18l2.68,3.2c.2.24.22.55.04.7l-1.31,1.1c-.18.15-.49.08-.69-.16l-2.68-3.19c-1.38,1.23-2.7,2.54-3.93,3.92l3.19,2.68c.24.2.31.51.16.69l-1.1,1.31c-.15.18-.47.16-.7-.04l-3.2-2.68c-1.15,1.45-2.21,2.96-3.19,4.55l3.62,2.09c.27.16.39.45.28.65l-.85,1.48c-.12.2-.43.24-.7.08l-3.62-2.09c-.88,1.63-1.66,3.3-2.35,5.04l3.93,1.43c.29.11.46.37.39.59l-.58,1.61c-.08.22-.38.31-.68.21l-3.93-1.43c-.58,1.74-1.06,3.54-1.44,5.37l4.11.73c.31.05.52.28.48.51l-.3,1.68c-.04.23-.32.38-.63.32l-4.11-.73c-.27,1.82-.43,3.67-.48,5.54h4.17c.31,0,.56.19.56.42v1.71c0,.23-.25.42-.56.42h-4.17c.05,1.87.21,3.72.48,5.53l4.11-.73c.31-.05.59.09.63.32l.3,1.68c.04.23-.18.45-.48.51l-4.11.73c.37,1.82.85,3.62,1.44,5.36l3.93-1.43c.29-.1.6-.01.68.2l.58,1.61c.08.22-.09.48-.39.59l-3.93,1.43c.69,1.73,1.47,3.41,2.35,5.04l3.62-2.09c.27-.16.58-.12.7.08l.85,1.48c.12.2,0,.49-.28.65l-3.61,2.09c.97,1.58,2.04,3.1,3.19,4.55l3.2-2.68c.24-.2.55-.22.7-.04l1.1,1.31c.15.18.07.49-.16.69l-3.19,2.68c1.23,1.38,2.54,2.7,3.93,3.92l2.68-3.19c.2-.24.5-.31.68-.16l1.31,1.1c.18.15.17.46-.04.7l-2.68,3.2c1.45,1.15,2.97,2.22,4.55,3.18l2.09-3.61c.15-.27.44-.4.65-.27l1.48.85c.2.12.24.43.09.7l-2.09,3.62c1.62.88,3.3,1.67,5.04,2.35l1.43-3.93c.1-.3.37-.47.59-.39l1.6.58c.22.08.31.38.21.67l-1.43,3.93c1.75.58,3.54,1.06,5.37,1.43l.73-4.11c.05-.31.28-.53.51-.49l1.69.3c.23.05.37.33.32.63l-.72,4.11c1.81.27,3.66.42,5.53.48v-4.17c0-.31.19-.56.42-.56h1.71c.23,0,.42.25.42.56v4.17c1.87-.05,3.72-.21,5.53-.48l-.73-4.11c-.05-.31.09-.59.32-.63l1.68-.3c.23-.03.46.18.52.49l.73,4.12c1.83-.37,3.62-.86,5.37-1.43l-1.43-3.93c-.11-.3-.02-.59.2-.67l1.6-.59c.22-.08.49.09.59.39l1.43,3.93c1.73-.69,3.41-1.47,5.04-2.35l-2.09-3.62c-.16-.27-.12-.58.08-.7l1.48-.85c.2-.12.49,0,.65.27l2.09,3.61c1.59-.97,3.1-2.04,4.55-3.18l-2.68-3.2c-.2-.24-.22-.55-.04-.7l1.31-1.1c.19-.15.49-.08.69.16l2.68,3.19c1.39-1.23,2.7-2.54,3.93-3.92l-3.19-2.68c-.24-.2-.31-.51-.16-.69l1.1-1.3c.15-.18.47-.16.7.04l3.19,2.68c1.15-1.45,2.22-2.96,3.19-4.55l-3.61-2.09c-.27-.15-.39-.45-.27-.65l.85-1.47c.12-.21.43-.25.7-.09l3.62,2.09c.88-1.62,1.66-3.31,2.35-5.04l-3.93-1.43c-.29-.11-.47-.37-.38-.59l.58-1.61c.08-.22.38-.31.67-.2l3.93,1.43c.58-1.74,1.06-3.54,1.44-5.36l-4.12-.73c-.3-.06-.52-.28-.48-.51l.3-1.68ZM92.19,226.95c-14.27,0-25.84-11.56-25.84-25.84s11.57-25.84,25.84-25.84,25.84,11.57,25.84,25.84-11.57,25.84-25.84,25.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M92.19,162.84c-21.14,0-38.27,17.14-38.27,38.28s17.14,38.27,38.27,38.27,38.27-17.13,38.27-38.27-17.14-38.28-38.27-38.28ZM92.19,225.76c-13.61,0-24.64-11.03-24.64-24.64s11.03-24.64,24.64-24.64,24.64,11.03,24.64,24.64-11.03,24.64-24.64,24.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M92.19,175.97c-13.89,0-25.15,11.26-25.15,25.15s11.26,25.15,25.15,25.15,25.15-11.26,25.15-25.15-11.26-25.15-25.15-25.15ZM92.19,219.42c-10.11,0-18.31-8.2-18.31-18.31s8.2-18.31,18.31-18.31,18.31,8.2,18.31,18.31-8.2,18.31-18.31,18.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M92.19,177.61c-12.98,0-23.51,10.52-23.51,23.51s10.52,23.51,23.51,23.51,23.51-10.52,23.51-23.51-10.52-23.51-23.51-23.51ZM92.19,218.23c-9.45,0-17.11-7.66-17.11-17.11s7.66-17.11,17.11-17.11,17.11,7.66,17.11,17.11-7.66,17.11-17.11,17.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M101.64,206.57c1.49-2.58,5.75-3.18,11.16-2.02.19-1.12.31-2.26.31-3.43s-.12-2.31-.31-3.43c-5.4,1.15-9.66.56-11.16-2.02-1.49-2.59.13-6.58,3.84-10.69-1.76-1.45-3.78-2.6-5.96-3.42-1.7,5.26-4.35,8.65-7.33,8.65s-5.63-3.4-7.33-8.65c-2.18.82-4.2,1.97-5.96,3.42,3.71,4.11,5.34,8.1,3.84,10.69-1.49,2.58-5.75,3.18-11.16,2.02-.19,1.12-.31,2.26-.31,3.43s.12,2.31.31,3.43c5.4-1.15,9.66-.56,11.16,2.02,1.49,2.59-.13,6.58-3.84,10.69,1.76,1.45,3.78,2.6,5.96,3.42,1.7-5.26,4.35-8.65,7.33-8.65s5.63,3.4,7.33,8.65c2.18-.82,4.2-1.97,5.96-3.42-3.71-4.11-5.34-8.1-3.84-10.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M114.21,203.17c.07-.68.1-1.36.1-2.06s-.04-1.38-.1-2.06c-.61-6.57-4.09-12.3-9.18-15.94-.03-.02-.06-.05-.09-.07-.53-.37-1.08-.72-1.64-1.05-.02,0-.03-.02-.05-.03-3.26-1.89-7.03-2.98-11.06-2.98s-7.8,1.1-11.06,2.98c-.02,0-.03.02-.05.03-.56.33-1.11.68-1.64,1.05-.03.02-.06.05-.09.07-.52.37-1.03.76-1.51,1.18,0,0,0,0,0,0h0c-4.26,3.64-7.12,8.86-7.66,14.76-.07.68-.1,1.36-.1,2.06s.04,1.38.1,2.06c.61,6.57,4.09,12.3,9.18,15.94.03.02.06.05.09.07.53.38,1.08.72,1.64,1.05.02,0,.03.02.05.03,3.26,1.89,7.03,2.98,11.06,2.98s7.8-1.1,11.06-2.98c.02,0,.03-.02.05-.03.56-.33,1.11-.67,1.64-1.05.03-.02.06-.05.1-.07.52-.37,1.03-.76,1.51-1.18,0,0,0,0,0,0h0c4.26-3.64,7.12-8.86,7.66-14.76ZM112.08,197.66c-5.58,1.56-10.12,1.22-11.6-1.33-1.47-2.55.5-6.66,4.65-10.72,3.59,3,6.11,7.24,6.94,12.05ZM99.14,182.16c-1.44,5.62-4.01,9.38-6.95,9.38s-5.51-3.76-6.95-9.38c2.17-.8,4.51-1.25,6.95-1.25s4.78.46,6.95,1.25ZM79.24,185.61c4.15,4.06,6.13,8.17,4.65,10.72-1.47,2.55-6.01,2.9-11.6,1.33.83-4.81,3.35-9.05,6.94-12.05ZM72.3,204.57c5.58-1.56,10.12-1.22,11.6,1.33,1.47,2.55-.5,6.66-4.65,10.72-3.59-3-6.11-7.24-6.94-12.05ZM85.24,220.07c1.44-5.62,4.01-9.38,6.95-9.38s5.51,3.76,6.95,9.38c-2.17.8-4.51,1.25-6.95,1.25s-4.78-.46-6.95-1.25ZM100.49,205.91c1.47-2.55,6.01-2.9,11.6-1.33-.83,4.81-3.35,9.05-6.94,12.05-4.15-4.06-6.13-8.17-4.65-10.72Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 92.19,
    cy: 201.11,
    r: 7.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M97.39,201.11c0,2.87-2.33,5.2-5.2,5.2s-5.2-2.33-5.2-5.2,2.33-5.2,5.2-5.2,5.2,2.33,5.2,5.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 461.06,
    cy: 201.11,
    r: 15.27,
    transform: "translate(-4.88 11.58) rotate(-1.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M461.06,155.44c-25.22,0-45.67,20.45-45.67,45.67s20.45,45.67,45.67,45.67,45.67-20.45,45.67-45.67-20.45-45.67-45.67-45.67ZM461.06,226.95c-14.27,0-25.84-11.56-25.84-25.84s11.57-25.84,25.84-25.84,25.84,11.57,25.84,25.84-11.57,25.84-25.84,25.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M502.3,207.52c.04-.23.32-.37.63-.32l4.11.73c.27-1.82.43-3.66.48-5.54h-4.17c-.31,0-.56-.19-.56-.42v-1.71c0-.24.25-.43.56-.43h4.17c-.05-1.87-.22-3.72-.48-5.54l-4.11.73c-.3.06-.59-.08-.63-.31l-.3-1.68c-.04-.23.18-.46.48-.51l4.12-.73c-.37-1.83-.86-3.62-1.43-5.37l-3.93,1.43c-.29.1-.59.01-.67-.21l-.58-1.61c-.08-.22.09-.48.38-.59l3.93-1.43c-.69-1.73-1.47-3.41-2.35-5.04l-3.62,2.09c-.27.16-.58.12-.7-.08l-.85-1.48c-.12-.21,0-.49.27-.65l3.61-2.08c-.97-1.58-2.04-3.1-3.19-4.55l-3.19,2.68c-.24.2-.55.22-.7.04l-1.1-1.31c-.15-.18-.08-.48.16-.68l3.19-2.68c-1.23-1.39-2.54-2.7-3.93-3.93l-2.68,3.19c-.2.24-.5.31-.68.16l-1.31-1.1c-.18-.15-.16-.47.04-.71l2.68-3.19c-1.45-1.15-2.97-2.22-4.55-3.19l-2.09,3.61c-.15.27-.44.39-.65.27l-1.48-.85c-.2-.11-.24-.43-.08-.7l2.09-3.62c-1.62-.88-3.3-1.66-5.04-2.35l-1.43,3.93c-.1.29-.36.47-.58.39l-1.61-.58c-.22-.08-.31-.39-.2-.68l1.43-3.93c-1.75-.58-3.54-1.06-5.37-1.44l-.73,4.12c-.05.31-.29.52-.51.48l-1.68-.29c-.23-.04-.37-.32-.32-.63l.73-4.11c-1.81-.27-3.66-.43-5.53-.48v4.17c0,.31-.19.56-.42.56h-1.71c-.24,0-.42-.25-.42-.56v-4.17c-1.87.05-3.72.21-5.53.48l.72,4.11c.05.31-.09.59-.32.62l-1.69.3c-.23.04-.46-.17-.51-.48l-.72-4.12c-1.83.38-3.62.86-5.37,1.44l1.43,3.93c.11.29.02.59-.21.67l-1.6.59c-.22.08-.48-.09-.59-.38l-1.43-3.93c-1.73.68-3.41,1.47-5.04,2.35l2.09,3.62c.15.27.12.58-.09.7l-1.48.85c-.2.12-.5,0-.65-.27l-2.09-3.61c-1.58.97-3.1,2.04-4.55,3.18l2.68,3.2c.2.24.22.55.04.7l-1.31,1.1c-.18.15-.49.08-.69-.16l-2.68-3.19c-1.38,1.23-2.7,2.54-3.93,3.92l3.19,2.68c.24.2.31.51.16.69l-1.1,1.31c-.15.18-.47.16-.7-.04l-3.2-2.68c-1.15,1.45-2.21,2.96-3.19,4.55l3.62,2.09c.27.16.39.45.28.65l-.85,1.48c-.12.2-.43.24-.7.08l-3.62-2.09c-.88,1.63-1.66,3.3-2.35,5.04l3.93,1.43c.29.11.46.37.39.59l-.58,1.61c-.08.22-.38.31-.68.21l-3.93-1.43c-.58,1.74-1.06,3.54-1.44,5.37l4.11.73c.31.05.52.28.48.51l-.3,1.68c-.04.23-.32.38-.63.32l-4.11-.73c-.27,1.82-.43,3.67-.48,5.54h4.17c.31,0,.56.19.56.42v1.71c0,.23-.25.42-.56.42h-4.17c.05,1.87.21,3.72.48,5.53l4.11-.73c.31-.05.59.09.63.32l.3,1.68c.04.23-.18.45-.48.51l-4.11.73c.37,1.82.85,3.62,1.44,5.36l3.93-1.43c.29-.1.6-.01.68.2l.58,1.61c.08.22-.09.48-.39.59l-3.93,1.43c.69,1.73,1.47,3.41,2.35,5.04l3.62-2.09c.27-.16.58-.12.7.08l.85,1.48c.12.2,0,.49-.28.65l-3.61,2.09c.97,1.58,2.04,3.1,3.19,4.55l3.2-2.68c.24-.2.55-.22.7-.04l1.1,1.31c.15.18.07.49-.16.69l-3.19,2.68c1.23,1.38,2.54,2.7,3.93,3.92l2.68-3.19c.2-.24.5-.31.68-.16l1.31,1.1c.18.15.17.46-.04.7l-2.68,3.2c1.45,1.15,2.97,2.22,4.55,3.18l2.09-3.61c.15-.27.44-.4.65-.27l1.48.85c.2.12.24.43.09.7l-2.09,3.62c1.62.88,3.3,1.67,5.04,2.35l1.43-3.93c.1-.3.37-.47.59-.39l1.6.58c.22.08.31.38.21.67l-1.43,3.93c1.75.58,3.54,1.06,5.37,1.43l.73-4.11c.05-.31.28-.53.51-.49l1.69.3c.23.05.37.33.32.63l-.72,4.11c1.81.27,3.66.42,5.53.48v-4.17c0-.31.19-.56.42-.56h1.71c.23,0,.42.25.42.56v4.17c1.87-.05,3.72-.21,5.53-.48l-.73-4.11c-.05-.31.09-.59.32-.63l1.68-.3c.23-.03.46.18.52.49l.73,4.12c1.83-.37,3.62-.86,5.37-1.43l-1.43-3.93c-.11-.3-.02-.59.2-.67l1.6-.59c.22-.08.49.09.59.39l1.43,3.93c1.73-.69,3.41-1.47,5.04-2.35l-2.09-3.62c-.16-.27-.12-.58.08-.7l1.48-.85c.2-.12.49,0,.65.27l2.09,3.61c1.58-.97,3.1-2.04,4.55-3.18l-2.68-3.2c-.2-.24-.22-.55-.04-.7l1.31-1.1c.19-.15.49-.08.69.16l2.68,3.19c1.39-1.23,2.7-2.54,3.93-3.92l-3.19-2.68c-.24-.2-.31-.51-.16-.69l1.1-1.3c.15-.18.47-.16.7.04l3.19,2.68c1.15-1.45,2.22-2.96,3.19-4.55l-3.61-2.09c-.27-.15-.39-.45-.27-.65l.85-1.47c.12-.21.43-.25.7-.09l3.62,2.09c.88-1.62,1.66-3.31,2.35-5.04l-3.93-1.43c-.29-.11-.47-.37-.38-.59l.58-1.61c.08-.22.38-.31.67-.2l3.93,1.43c.58-1.74,1.06-3.54,1.43-5.36l-4.12-.73c-.3-.06-.52-.28-.48-.51l.3-1.68ZM461.06,226.95c-14.27,0-25.84-11.56-25.84-25.84s11.57-25.84,25.84-25.84,25.84,11.57,25.84,25.84-11.57,25.84-25.84,25.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M461.06,162.84c-21.14,0-38.27,17.14-38.27,38.28s17.14,38.27,38.27,38.27,38.27-17.13,38.27-38.27-17.14-38.28-38.27-38.28ZM461.06,225.76c-13.61,0-24.64-11.03-24.64-24.64s11.03-24.64,24.64-24.64,24.64,11.03,24.64,24.64-11.03,24.64-24.64,24.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M461.06,175.97c-13.89,0-25.15,11.26-25.15,25.15s11.26,25.15,25.15,25.15,25.15-11.26,25.15-25.15-11.26-25.15-25.15-25.15ZM461.06,219.42c-10.11,0-18.31-8.2-18.31-18.31s8.2-18.31,18.31-18.31,18.31,8.2,18.31,18.31-8.2,18.31-18.31,18.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M461.06,177.61c-12.98,0-23.51,10.52-23.51,23.51s10.52,23.51,23.51,23.51,23.51-10.52,23.51-23.51-10.52-23.51-23.51-23.51ZM461.06,218.23c-9.45,0-17.11-7.66-17.11-17.11s7.66-17.11,17.11-17.11,17.11,7.66,17.11,17.11-7.66,17.11-17.11,17.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M470.51,206.57c1.49-2.58,5.75-3.18,11.16-2.02.19-1.12.31-2.26.31-3.43s-.12-2.31-.31-3.43c-5.4,1.15-9.66.56-11.16-2.02-1.49-2.59.13-6.58,3.84-10.69-1.76-1.45-3.78-2.6-5.96-3.42-1.7,5.26-4.35,8.65-7.33,8.65s-5.63-3.4-7.33-8.65c-2.18.82-4.2,1.97-5.96,3.42,3.71,4.11,5.34,8.1,3.84,10.69-1.49,2.58-5.75,3.18-11.16,2.02-.19,1.12-.31,2.26-.31,3.43s.12,2.31.31,3.43c5.4-1.15,9.66-.56,11.16,2.02,1.49,2.59-.13,6.58-3.84,10.69,1.76,1.45,3.78,2.6,5.96,3.42,1.7-5.26,4.35-8.65,7.33-8.65s5.63,3.4,7.33,8.65c2.18-.82,4.2-1.97,5.96-3.42-3.71-4.11-5.34-8.1-3.84-10.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M483.08,203.17c.07-.68.1-1.36.1-2.06s-.04-1.38-.1-2.06c-.61-6.57-4.09-12.3-9.18-15.94-.03-.02-.06-.05-.09-.07-.53-.37-1.08-.72-1.64-1.05-.02,0-.03-.02-.05-.03-3.26-1.89-7.03-2.98-11.06-2.98s-7.8,1.1-11.06,2.98c-.02,0-.03.02-.05.03-.56.33-1.11.68-1.64,1.05-.03.02-.06.05-.09.07-.52.37-1.03.76-1.51,1.18,0,0,0,0,0,0h0c-4.26,3.64-7.12,8.86-7.66,14.76-.07.68-.1,1.36-.1,2.06s.04,1.38.1,2.06c.61,6.57,4.09,12.3,9.18,15.94.03.02.06.05.09.07.53.38,1.08.72,1.64,1.05.02,0,.03.02.05.03,3.26,1.89,7.03,2.98,11.06,2.98s7.8-1.1,11.06-2.98c.02,0,.03-.02.05-.03.56-.33,1.11-.67,1.64-1.05.03-.02.06-.05.1-.07.52-.37,1.03-.76,1.51-1.18,0,0,0,0,0,0h0c4.26-3.64,7.12-8.86,7.66-14.76ZM480.95,197.66c-5.58,1.56-10.12,1.22-11.6-1.33-1.47-2.55.5-6.66,4.65-10.72,3.59,3,6.11,7.24,6.94,12.05ZM468.01,182.16c-1.44,5.62-4.01,9.38-6.95,9.38s-5.51-3.76-6.95-9.38c2.17-.8,4.51-1.25,6.95-1.25s4.78.46,6.95,1.25ZM448.11,185.61c4.15,4.06,6.13,8.17,4.65,10.72-1.47,2.55-6.01,2.9-11.6,1.33.83-4.81,3.35-9.05,6.94-12.05ZM441.17,204.57c5.58-1.56,10.12-1.22,11.6,1.33,1.47,2.55-.5,6.66-4.65,10.72-3.59-3-6.11-7.24-6.94-12.05ZM454.11,220.07c1.44-5.62,4.01-9.38,6.95-9.38s5.51,3.76,6.95,9.38c-2.17.8-4.51,1.25-6.95,1.25s-4.78-.46-6.95-1.25ZM469.36,205.91c1.47-2.55,6.01-2.9,11.6-1.33-.83,4.81-3.35,9.05-6.94,12.05-4.15-4.06-6.13-8.17-4.65-10.72Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 461.06,
    cy: 201.11,
    r: 7.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-50",
    cx: 461.06,
    cy: 201.11,
    r: 5.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M458.64,135.27c-23.29,0-43.55,8.08-53.97,19.99-.34-2.45-.53-4.95-.53-7.49,0-30.83,25.69-55.82,57.37-55.82s57.37,24.99,57.37,55.82c0,4.82-.63,9.5-1.81,13.96-8.01-15.36-31.14-26.47-58.44-26.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M94.08,138.63c23.69,0,44.31,8.16,54.91,20.2.34-2.48.54-5,.54-7.56,0-31.14-26.13-56.39-58.37-56.39s-58.37,25.25-58.37,56.39c0,4.87.64,9.6,1.84,14.11,8.15-15.52,31.68-26.74,59.45-26.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M509.94,140.66s4.24,13.85,6.33,27.5c2.1,13.65,3.17,30.2,3.8,31.15.63.95,1.76-26.52.29-38.91-1.48-12.39-12.6-43.35-10.42-19.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M142.11,140.66s4.24,13.85,6.33,27.5c2.1,13.65,3.17,30.2,3.8,31.15s1.76-26.52.29-38.91c-1.48-12.39-12.6-43.35-10.42-19.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M220.34,89.18h0c-1.22.59-2.7.08-3.29-1.13l-11.85-24.29c-.59-1.22-.08-2.7,1.13-3.29h0c1.22-.59,2.7-.08,3.29,1.13l11.85,24.29c.59,1.22.08,2.7-1.13,3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M293.59,56.19c1.16-1.23,1.85-2.91,1.76-4.73l-.63-12.22c-.18-3.53-3.22-6.27-6.76-6.09h-.21c-3.53.19-6.27,3.23-6.09,6.77l.63,12.22c.1,1.83.97,3.44,2.27,4.55-2.68,1.43-4.75,3.98-5.45,7.16l-7.8,35.53c-1.27,5.77,2.42,11.53,8.19,12.79s11.53-2.42,12.79-8.19l7.8-35.53c1.14-5.18-1.73-10.35-6.5-12.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M391.15,56.19c1.16-1.23,1.85-2.91,1.76-4.73l-.63-12.22c-.18-3.53-3.22-6.27-6.76-6.09h-.21c-3.53.19-6.27,3.23-6.09,6.77l.63,12.22c.1,1.83.97,3.44,2.27,4.55-2.68,1.43-4.75,3.98-5.45,7.16l-7.8,35.53c-1.27,5.77,2.42,11.53,8.19,12.79,5.77,1.27,11.53-2.42,12.79-8.19l7.8-35.53c1.14-5.18-1.73-10.35-6.5-12.26Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M374.82,21.19c-17.2-1.19-41.46-1.21-64.31-.41-1.6.06-2.86,1.38-2.86,2.98v46.74c0,1.69,1.41,3.04,3.09,2.97,55.94-2.15,74.78-7,74.78-20.66v-12.56c0-12.01-4.69-18.64-10.7-19.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M256.08,25.07c-10.78,1.81-31.43,7.62-74.81,39.08-2.09,1.51-3.26,6.21-3.4,9.42-.07,1.65,1.38,3.02,3.18,2.98,0,0,88.04-1.97,104.28-2.33,1.43-.03,2.56-1.2,2.56-2.63V24.7c0-1.53-1.29-2.74-2.82-2.63-11.72.8-21.91,1.82-28.98,3.01Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M405.95,119.71s58.11-35.02,100.24,7.59c12.7,12.85,18.66,37.12,18.66,37.12,16.28-5.56,22.84-8.27,49.8-18.4,19.43-7.3,10.7-68.04,7.7-78.53h0s-175.56,0-175.56,0c.05,8.06.01,17.03.01,26.96,0,6.46-.36,15.72-.86,25.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M391.94,14.8c-11.7-7.13-108.75-5.19-140.99,0-12.03,1.94-42.66,14.86-95.67,53.73-25.98,2.53-102.64,10.5-114.21,17.59-13.98,8.56-31.66,39.37-21.4,78.31h18.4c0-29.9,24.23-54.13,54.13-54.13s54.13,24.24,54.13,54.13h243.34c4.98,0,9.14-3.76,9.67-8.7,1.24-11.73,3.45-45.18,3.45-61.26,0-46.86.86-72.53-10.84-79.66ZM287.88,71.76c0,1.43-1.13,2.6-2.56,2.63-16.24.36-104.28,2.33-104.28,2.33-1.8.04-3.25-1.32-3.18-2.98.14-3.21,1.32-7.91,3.4-9.42,43.39-31.46,64.03-37.27,74.81-39.08,7.07-1.19,17.26-2.21,28.98-3.01,1.52-.1,2.82,1.11,2.82,2.63v46.89ZM385.52,52.98c0,13.66-18.84,18.51-74.78,20.66-1.69.06-3.09-1.29-3.09-2.98V23.93c0-1.6,1.26-2.92,2.86-2.98,22.85-.8,47.11-.78,64.31.41,6.02.42,10.7,7.04,10.7,19.06v12.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M564.63,112.93h0s-32.87-.61-79.41-.48c7.19,3.3,14.28,8.1,20.97,14.87,4.49,4.55,8.14,10.52,10.98,16.34,24.01-5.83,50.46-16.53,47.46-30.72Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "405.95 119.71 405.95 119.71 405.95 119.71 405.95 119.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "405.95 119.71 405.95 119.71 405.95 119.71 405.95 119.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M178.54,145.55c-.26,4.91,120.95,6.07,221.29,4.89.81-9.29,1.8-23.94,2.4-36.96-105.04,2.45-222.5,10.11-223.69,32.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 174.33,
    y: 176.33,
    width: 209.46,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 174.33,
    y: 179.52,
    width: 209.46,
    height: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M160.15,170.77h16.82v16.44h-16.82c-2.05,0-3.72-1.67-3.72-3.72v-9c0-2.05,1.67-3.72,3.72-3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M381.09,170.77h16.82v16.44h-16.82c-2.05,0-3.72-1.67-3.72-3.72v-9c0-2.05,1.67-3.72,3.72-3.72Z",
    transform: "translate(775.29 357.98) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M53.96,129.44s-6.8,11.79-9.42,23.98c-2.62,12.18-2.9,27.35-4.03,28.07-1.13.72-6.38-25.23-4.84-36.4,1.54-11.17,19.98-37.09,18.29-15.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M92.19,88.54c-36.87,0-66.76,27.71-66.76,61.89,0,4.81.61,9.49,1.73,13.99l8.55,1.6c1.46.27,2.85-.79,2.92-2.27,1.46-28.44,24.87-52.96,53.55-52.96s52.4,24.23,53.57,52.88c.05,1.19,1.08,2.1,2.26,1.94l9.19-1.21c1.12-4.5,1.73-9.18,1.73-13.99,0-34.18-29.89-61.89-66.76-61.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M92.19,97.64c-33.78,0-61.26,27.4-61.26,61.09,0,2.14.13,4.31.36,6.47l.87.16c-.25-2.21-.38-4.44-.38-6.63,0-33.21,27.1-60.23,60.4-60.23s60.4,27.02,60.4,60.23c0,2.1-.13,4.23-.35,6.35l.87-.11c.22-2.08.34-4.17.34-6.24,0-33.68-27.48-61.09-61.26-61.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M18.01,125.98h37.86c.44-.43.89-.87,1.35-1.28H18.25c-.09.42-.16.86-.24,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M37.2,94.55c-.19,0-.37-.07-.5-.19-.23-.23-.2-.57.08-.76.64-.44,16.87-10.78,127.14-16.02.38-.02.67.21.69.5.02.3-.26.55-.62.57-109.84,5.23-126.23,15.67-126.38,15.78-.12.08-.27.13-.42.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M374.38,19.14c-32.77-2.19-93.63-.26-118.41,3.76-11.91,1.93-32.69,7.97-75.52,37.97-3.44,2.41-4.6,8.35-4.75,11.48-.08,1.62.54,3.16,1.73,4.34,1.21,1.2,2.91,1.87,4.67,1.87.05,0,.1,0,.15,0l104.65-2.26c74.66-1.69,101.17-5.52,101.17-23.69v-12.02c0-15.16-7.39-21.03-13.71-21.45ZM287.88,71.76c0,1.43-1.13,2.6-2.56,2.63-16.24.36-104.28,2.33-104.28,2.33-1.8.04-3.25-1.32-3.18-2.98.14-3.21,1.32-7.91,3.4-9.42,43.39-31.46,64.03-37.27,74.81-39.08,7.07-1.19,17.26-2.21,28.98-3.01,1.52-.1,2.82,1.11,2.82,2.63v46.89ZM385.52,52.98c0,13.66-18.84,18.51-74.78,20.66-1.69.06-3.09-1.29-3.09-2.98V23.93c0-1.6,1.26-2.92,2.86-2.98,22.85-.8,47.11-.78,64.31.41,6.02.42,10.7,7.04,10.7,19.06v12.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M310.62,74.49c-.99,0-1.93-.38-2.65-1.07-.76-.73-1.18-1.71-1.18-2.76V23.92c0-2.08,1.62-3.76,3.69-3.83,24.64-.87,48.11-.72,64.4.41h0c6.99.48,11.5,8.3,11.5,19.91v12.56c0,14.09-18.37,19.32-75.61,21.52-.05,0-.1,0-.15,0ZM341.12,21.24c-9.66,0-20.01.18-30.59.56-1.14.04-2.04.97-2.04,2.12v46.74c0,.58.23,1.12.65,1.53.42.4.97.61,1.55.59,55.99-2.15,73.96-6.96,73.96-19.81v-12.56c0-10.64-3.89-17.79-9.91-18.2h0c-9.25-.64-20.84-.97-33.64-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M287.62,22.31c-.71-.66-1.66-1-2.62-.93-12.19.83-22.24,1.87-29.06,3.02h0c-11.77,1.98-32.37,8.19-75.17,39.23-2.5,1.82-3.62,7.02-3.76,10.08-.04.99.32,1.94,1.04,2.67.75.77,1.81,1.2,2.92,1.2.03,0,.06,0,.09,0l104.28-2.33c1.9-.04,3.39-1.57,3.39-3.48V24.87c0-.96-.4-1.89-1.11-2.55ZM287.02,71.76c0,.97-.76,1.75-1.72,1.77l-89.24,2v-20.51c37.31-25.08,54.19-27.93,60.16-28.94h0c6.77-1.14,16.76-2.17,28.9-3,.49-.04.97.14,1.34.48.37.34.57.8.57,1.3v46.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M392.64,27.58c-1.31-7.51-8.02-12.29-18.42-13.13-12.57-1.01-85.06-4.14-126.3,5.4-21.43,4.96-55.84,23.65-78.34,42.56-9.98,8.39-6.3,56.18-6.14,58.21.59,7.36,1.77,15.57,3.03,24.25.37,2.54.74,5.14,1.11,7.77l.16,1.18c.52,3.81,1.13,7.53,2.02,10.6h.87c-.52-1.77-.94-3.6-1.28-5.56h210.96c5.56,0,10.15-4.1,10.68-9.53,1.57-16.1,4.22-45.32,4.22-60.07,0-20.7-1.6-56.07-2.57-61.69ZM169.21,158.02c-.26-1.6-.46-3.11-.63-4.31l-.16-1.18c-.37-2.64-.74-5.23-1.11-7.78-1.25-8.67-2.44-16.86-3.02-24.2-1.46-18.31-1.87-51.02,5.84-57.5,22.41-18.83,56.67-37.45,77.99-42.38,14.11-3.26,31.9-5.04,49.69-5.92v143.27h-128.59ZM390.16,149.26c-.49,4.99-4.72,8.76-9.84,8.76h-81.66V14.71c33.77-1.63,67.33-.08,75.5.58,10.13.81,16.4,5.23,17.65,12.43.97,5.59,2.56,40.87,2.56,61.54,0,14.72-2.64,43.9-4.21,59.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M35.54,90.51c-6.9,6.73-13.7,18.14-16.95,32.67,8.54.26,16.67-4.88,19.79-13.33,2.5-6.76,1.18-13.98-2.84-19.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M18.73,122.58c7.65-.95,14.42-5.94,16.92-13.34,1.94-5.75.87-11.69-2.36-16.36-5.99,6.78-11.62,17.03-14.56,29.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M27.68,111.36c0,2.48.79,4.74,2.07,6.45,2.66-2.23,4.75-5.14,5.91-8.58.85-2.52,1.09-5.06.86-7.53-.24-.02-.47-.04-.72-.04-4.48,0-8.12,4.34-8.12,9.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M192.38,53.01h8.42c1.33,0,2.41,1.08,2.41,2.41v15.48c0,1.04-.85,1.89-1.89,1.89h-17.16c-2.24,0-4.06-1.82-4.06-4.06v-3.45c0-6.77,5.5-12.27,12.27-12.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M459.83,88.54c-21.94,0-41.4,9.81-53.57,24.96-.09,2.04-.2,4.12-.31,6.21-.75,14.02-1.82,28.61-2.56,35.73h.64c1.9,0,3.57-1.27,4.06-3.11,6.19-23.27,27-41.52,51.74-41.52,28.87,0,52.4,24.23,53.57,52.88.05,1.19,1.08,2.1,2.26,1.94l9.19-1.21c1.12-4.5,1.73-9.18,1.73-13.99,0-34.18-29.89-61.89-66.76-61.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M459.83,97.64c-23.76,0-44.39,13.57-54.54,33.33-.05.74-.09,1.48-.14,2.21,9.66-20.47,30.53-34.69,54.68-34.69,33.31,0,60.4,27.02,60.4,60.23,0,2.1-.13,4.23-.35,6.35l.87-.11c.22-2.08.34-4.17.34-6.24,0-33.68-27.48-61.09-61.26-61.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M587.01,156.15h-11.79l8.56-17.26h15.26v5.22c0,6.65-5.39,12.04-12.04,12.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M570.52,79.2h-157.18c-.35,0-.64-.29-.64-.64s.29-.64.64-.64h157.18c.35,0,.64.29.64.64s-.29.64-.64.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M424.35,101.13h-7.85c-2.45,0-4.45-1.99-4.45-4.45v-9.47c0-2.45,2-4.45,4.45-4.45h13.79c2.45,0,4.45,2,4.45,4.45v3.54c0,5.72-4.66,10.38-10.38,10.38ZM416.5,83.16c-2.24,0-4.05,1.82-4.05,4.05v9.47c0,2.24,1.82,4.05,4.05,4.05h7.85c5.51,0,9.99-4.48,9.99-9.99v-3.54c0-2.24-1.82-4.05-4.05-4.05h-13.79Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 269.13,
    y: 82.53,
    width: 16.58,
    height: 12.02,
    rx: 5.9,
    ry: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 269.99,
    y: 83.15,
    width: 14.86,
    height: 10.77,
    rx: 5.29,
    ry: 5.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 263.85,
    y: 85.53,
    width: 26.64,
    height: 6.03,
    rx: 1.64,
    ry: 1.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 363.3,
    y: 78.23,
    width: 16.58,
    height: 12.02,
    rx: 5.9,
    ry: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 364.16,
    y: 78.86,
    width: 14.86,
    height: 10.77,
    rx: 5.29,
    ry: 5.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 358.03,
    y: 81.23,
    width: 26.64,
    height: 6.03,
    rx: 1.64,
    ry: 1.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 144.01,
    y: 91.72,
    width: 8.73,
    height: 5.67,
    rx: 2.23,
    ry: 2.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 144.69,
    y: 92.16,
    width: 7.37,
    height: 4.78,
    rx: 1.88,
    ry: 1.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 145.5,
    y: 93.21,
    width: 5.75,
    height: 3.73,
    rx: 1.47,
    ry: 1.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M12.92,181.34c-2.77,0-5.37-1.58-6.41-4.14-16.56-41.08,3.57-78.9,4.43-80.49,1.71-3.15,5.83-4.41,9.2-2.8,3.37,1.6,4.71,5.44,3.01,8.59-.19.35-18.22,34.52-3.83,70.19,1.33,3.3-.46,6.99-3.99,8.24-.79.28-1.61.41-2.41.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M17.84,184.46c-2.77,0-5.37-1.69-6.41-4.43-16.56-43.98,3.57-84.48,4.43-86.18,1.71-3.37,5.83-4.72,9.2-3,3.37,1.71,4.71,5.83,3.01,9.2-.19.38-18.22,36.97-3.83,75.16,1.33,3.54-.46,7.49-3.99,8.82-.79.3-1.61.44-2.41.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M24.47,103.46c0,2.85-2.31,5.16-5.16,5.16s-5.16-2.31-5.16-5.16,2.31-5.16,5.16-5.16,5.16,2.31,5.16,5.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M23.59,103.46c0,2.36-1.91,4.27-4.27,4.27s-4.27-1.91-4.27-4.27,1.91-4.27,4.27-4.27,4.27,1.91,4.27,4.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M22.03,175.28c0,2.85-2.31,5.16-5.16,5.16s-5.16-2.31-5.16-5.16,2.31-5.16,5.16-5.16,5.16,2.31,5.16,5.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M21.14,175.28c0,2.36-1.91,4.27-4.27,4.27s-4.27-1.91-4.27-4.27,1.91-4.27,4.27-4.27,4.27,1.91,4.27,4.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M268.41,5.13h106.34c2.91,0,5.95,6.66,6.34,9.15l8.84.88c-.42-5.33-9.08-15.17-15.19-15.17h-106.34c-6.11,0-14.2,10.58-14.62,15.91l9.02-.87c.4-2.49,2.68-9.91,5.6-9.91Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 272.51,
    width: 98.62,
    height: 5.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 272.51,
    y: 1.83,
    width: 98.62,
    height: 1.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M584.61,79.28c-8.89,2.37-15.45,10.46-15.45,20.1v16.28c0,2.47,2,4.48,4.48,4.48h12.83c1.2-13.7-.23-29.78-1.86-40.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M571.16,99.42v14.45c0,2.19,1.93,3.97,4.31,3.97h11.17c.8-12.12-.29-25.71-1.67-35.95-8.01,2.42-13.81,9.34-13.81,17.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M585.93,90.18h-7.36c-1.26,0-2.28,1.02-2.28,2.28v10.19c0,1.26,1.02,2.28,2.28,2.28h8.27c-.13-5.05-.46-10.08-.91-14.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M576.29,108.1v4.51c0,1.26,1.02,2.28,2.28,2.28h8.2c.12-2.99.15-6.03.09-9.08h-8.29c-1.26,0-2.28,1.02-2.28,2.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 577.52,
    y: 106.15,
    width: 1.75,
    height: 7.17,
    rx: 0.51,
    ry: 0.51,
    transform: "translate(1156.79 219.47) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 577.95,
    y: 106.37,
    width: 1.17,
    height: 4.78,
    rx: 0.34,
    ry: 0.34,
    transform: "translate(1157.07 217.51) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 577.43,
    y: 90.82,
    width: 1.85,
    height: 12.91,
    rx: 0.55,
    ry: 0.55,
    transform: "translate(1156.71 194.55) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 577.88,
    y: 91.05,
    width: 1.24,
    height: 5.31,
    rx: 0.37,
    ry: 0.37,
    transform: "translate(1157 187.42) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 579.79,
    y: 106.15,
    width: 1.75,
    height: 7.17,
    rx: 0.51,
    ry: 0.51,
    transform: "translate(1161.33 219.47) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 580.22,
    y: 106.37,
    width: 1.17,
    height: 4.78,
    rx: 0.34,
    ry: 0.34,
    transform: "translate(1161.6 217.51) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 579.58,
    y: 90.82,
    width: 1.85,
    height: 12.91,
    rx: 0.55,
    ry: 0.55,
    transform: "translate(1161.02 194.55) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 580.04,
    y: 91.05,
    width: 1.23,
    height: 5.31,
    rx: 0.37,
    ry: 0.37,
    transform: "translate(1161.31 187.42) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 582.06,
    y: 106.15,
    width: 1.75,
    height: 7.17,
    rx: 0.51,
    ry: 0.51,
    transform: "translate(1165.86 219.47) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 582.48,
    y: 106.37,
    width: 1.17,
    height: 4.78,
    rx: 0.34,
    ry: 0.34,
    transform: "translate(1166.14 217.51) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 581.74,
    y: 90.82,
    width: 1.85,
    height: 12.91,
    rx: 0.55,
    ry: 0.55,
    transform: "translate(1165.33 194.55) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 582.19,
    y: 91.05,
    width: 1.23,
    height: 5.31,
    rx: 0.37,
    ry: 0.37,
    transform: "translate(1165.62 187.42) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 581.58,
    y: 83.67,
    width: 1.52,
    height: 5.54,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(1164.68 172.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 581.95,
    y: 83.89,
    width: 1.01,
    height: 3.12,
    rx: 0.32,
    ry: 0.32,
    transform: "translate(1164.92 170.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M584.83,106.15h.74c.28,0,.51.23.51.51v6.15c0,.28-.23.51-.51.51h-.74c-.28,0-.51-.23-.51-.51v-6.15c0-.28.23-.51.51-.51Z",
    transform: "translate(1170.4 219.47) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 584.75,
    y: 106.37,
    width: 1.17,
    height: 4.78,
    rx: 0.34,
    ry: 0.34,
    transform: "translate(1170.67 217.51) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 583.9,
    y: 90.82,
    width: 1.85,
    height: 12.91,
    rx: 0.55,
    ry: 0.55,
    transform: "translate(1169.64 194.55) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 584.35,
    y: 91.05,
    width: 1.23,
    height: 5.31,
    rx: 0.37,
    ry: 0.37,
    transform: "translate(1169.93 187.42) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 583.35,
    y: 83.67,
    width: 1.52,
    height: 5.54,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(1168.22 172.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 583.72,
    y: 83.89,
    width: 1.01,
    height: 3.12,
    rx: 0.32,
    ry: 0.32,
    transform: "translate(1168.46 170.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M207.61,58.14s34.38-21.54,41.36-23.96c6.99-2.42,32.38-5.56,32.81-4.99.43.57,2,19.83,0,23.96-2,4.14-32.66,12.27-48.78,13.12-16.12.86-26.76,2.34-25.39-8.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M314.11,33.21c.05-3.44,2.81-6.22,6.25-6.24,14.46-.1,50.39-.3,52.66.04,2.85.43,11.99,13.39,7.86,17.81-4.14,4.42-54.35,3.8-62.06,4.65-6.83.76-4.96-.47-4.71-16.26Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Wd);
export default __webpack_public_path__ + "static/media/4WD.f2ed243953dd3edc8f592a7f14808b20.svg";
export { ForwardRef as ReactComponent };